import React from "react";
import { useIntl } from "react-intl";
import type { MessageDescriptor } from "react-intl";
import type { FC } from "react";

export const FormattedHTMLMessage: FC<MessageDescriptor> = (props) => {
  const intl = useIntl();
  const __html = intl.formatMessage(props);
  return <span dangerouslySetInnerHTML={{ __html }}></span>;
};
